import React, { useEffect, useState } from "react";
import { authFetch, logout, useAuth } from "../../auth";
import {
  Container,
  Button,
  Form,
  InputGroup,
  Row,
  Col,
  Tabs,
  Tab,
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUnlockAlt, faCamera } from "@fortawesome/free-solid-svg-icons";
import ProfileImg from "../../assets/img/profile-cover.jpg";
import { useHistory } from "react-router";
import { Routes } from "../../routes";
import { UserCompanyInfoForm } from "../../components/Forms";
import { FormattedMessage } from "react-intl";

export default () => {
  const [user, setUser] = useState({
    photoUrl: "",
    email: "",
    pwd: "",
  });
  const [photo, setPhoto] = useState("");
  const { photoUrl, email, pwd } = user; // 파일 base64
  const [pwd2, setPwd2] = useState("");
  const [company, setCompany] = useState(null);
  const history = useHistory();
  const [logged] = useAuth();

  const onTabSelect = (key) => {
    if (key === "company" && !company) {
      authFetch(process.env.REACT_APP_API_URL + "/api/user/company")
        .then((resp) => resp.json())
        .then((resp) => {
          if (resp.userCompany) {
            setCompany(resp.userCompany);
          } else {
            setCompany(null);
          }
        });
    }
  };

  if (!logged) {
    history.push("/sign-in");
  }

  useEffect(() => {
    authFetch(process.env.REACT_APP_API_URL + "/api/user", {
      method: "get",
    })
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp.email) {
          setUser((prev) => ({ ...prev, email: resp.email }));
        } else {
          console.log("edit profile: error!");
        }
      });
  }, []);

  const onPwdChange = (e) => {
    const { value, name } = e.target;

    if (name === "pwd") {
      setUser((prev) => ({
        ...prev,
        [name]: value,
      }));
    } else {
      setPwd2(value);
    }
  };

  const onProfileUpdate = (e) => {
    e.preventDefault();

    if (!pwd || !pwd2) {
      console.log("비밀번호를 입력해주세요.");
      return;
    }
    if (pwd !== pwd2) {
      console.log("비밀번호가 일치하지 않습니다.");
      return;
    }

    authFetch("api/profile", {
      method: "post",
      body: JSON.stringify({
        pwd,
      }),
    }).then((resp) => {
      if (resp.status === 200) {
        console.log("프로필 업데이트 성공!");
        logout();
      } else {
        console.log("프로필 업데이트 실패");
      }
    });
  };

  const onPhotoUpdate = (e) => {
    let reader = new FileReader();

    reader.onloadend = () => {
      // 2. 읽기가 완료되면 아래의 코드 실행
      const base64 = reader.result;
      if (base64) {
        setUser((prev) => ({ ...prev, photoUrl: base64.toString() })); // 3. 파일 64 상태 업데이트
      }
    };
    if (e.target.files[0]) {
      reader.readAsDataURL(e.target.files[0]); // 1. 파일을 읽어 버퍼에 저장
      setPhoto(e.target.files[0]); // 파일 상태 업데이트
    }
  };

  return (
    <main>
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <Container>
          <Tabs defaultActiveKey="profile" id="tab" onSelect={onTabSelect}>
            <Tab eventKey="profile" title="Profile">
              <Row className="justify-content-center form-bg-image">
                <Col
                  xs={12}
                  className="d-flex align-items-center justify-content-center"
                >
                  <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100">
                    <div className="text-center text-md-center mb-4 mt-md-0">
                      <h3 className="mb-0">
                        <FormattedMessage id="manageProfile" />
                      </h3>
                    </div>
                    <Form>
                      <Form.Group>
                        <div className="text-center position-relative">
                          <img
                            src={photoUrl ? photoUrl : ProfileImg}
                            className="rounded-circle border"
                            width="200px"
                            height="200px"
                            alt="profile"
                            draggable="false"
                          />
                          <div
                            className="position-absolute top-0"
                            style={{ left: "55%" }}
                          >
                            <input
                              type="file"
                              id="file-upload"
                              accept="image/jpg, image/png, image/jpeg"
                              className="form-control-file position-absolute"
                              onChange={onPhotoUpdate}
                              style={{ zIndex: -1, opacity: 0 }}
                            />
                            <label htmlFor="file-upload">
                              <span
                                className="bg-light user-avatar md-avatar"
                                style={{ cursor: "pointer" }}
                              >
                                <FontAwesomeIcon
                                  className="m-2"
                                  icon={faCamera}
                                />
                              </span>
                            </label>
                          </div>
                        </div>
                      </Form.Group>
                      <div className="mt-4">
                        <h5>
                          <FormattedMessage id="registedEmail" />
                        </h5>
                        <p className="mb-4">{email}</p>
                        <h5>
                          <FormattedMessage id="changePassword" />
                        </h5>
                        <Form.Group id="password" className="mb-4">
                          <Form.Label>
                            <FormattedMessage id="password" />
                          </Form.Label>
                          <InputGroup>
                            <InputGroup.Text>
                              <FontAwesomeIcon icon={faUnlockAlt} />
                            </InputGroup.Text>
                            <Form.Control
                              required
                              type="password"
                              placeholder="Password"
                              name="pwd"
                              value={pwd}
                              onChange={onPwdChange}
                            />
                          </InputGroup>
                        </Form.Group>
                        <Form.Group id="confirmPassword" className="mb-4">
                          <Form.Label>
                            <FormattedMessage id="password" />{" "}
                            <FormattedMessage id="confirm" />
                          </Form.Label>
                          <InputGroup>
                            <InputGroup.Text>
                              <FontAwesomeIcon icon={faUnlockAlt} />
                            </InputGroup.Text>
                            <Form.Control
                              required
                              type="password"
                              placeholder="Confirm Password"
                              name="pwd2"
                              value={pwd2}
                              onChange={onPwdChange}
                            />
                          </InputGroup>
                        </Form.Group>

                        <Button
                          variant="primary"
                          type="submit"
                          className="w-100"
                          onClick={onProfileUpdate}
                        >
                          <FormattedMessage id="toEdit" />
                        </Button>
                      </div>
                    </Form>
                  </div>
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="company" title="Company">
              <Row className="justify-content-center form-bg-image">
                <Col
                  xs={12}
                  className="d-flex align-items-center justify-content-center"
                >
                  <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100">
                    {company ? (
                      <>
                        <div className="text-center text-md-center mb-4 mt-md-0">
                          <h3 className="mb-0">회사정보 수정</h3>
                        </div>
                        <UserCompanyInfoForm
                          company={company}
                          setCompany={setCompany}
                        />
                      </>
                    ) : (
                      <div>회사 정보가 존재하지 않습니다</div>
                    )}
                  </div>
                </Col>
              </Row>
            </Tab>
          </Tabs>
        </Container>
      </section>
    </main>
  );
};
